<template>
  <!-- 系统目录 健康档案 -->
  <div class="box">
    <!-- main -->
    <div class="main">
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!-- 标题和搜索区域 -->
        <div class="main-icon">
          <div class="main-icon-a">
            <i 
              :class="iconComes"
              style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;background-color: #00557f;color: #fff;"
            ></i>
            <span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">
              {{ CatalogueName }}
            </span>
          </div>
          
          <!-- 搜索框区域 -->
          <div class="main-icon-c">
            <span style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">
              关键字：
            </span>
            <el-input 
              size="mini" 
              placeholder="编码、名称、拼音简码" 
              v-model="searchValue"
              @keyup.enter.native="handleSearch"
              style="width: 200px; margin-right: 12px;"
            >
              <i slot="suffix" class="el-input__icon el-icon-Ssearch" style="cursor: pointer;" @click="handleSearch"></i>
            </el-input>
            
            <!-- 刷新按钮 -->
            <el-button 
              type="warning" 
              :loading="loading" 
              icon="el-icon-refresh" 
              size="mini"
              @click="handleRefresh"
              style="margin-right: 8px;"
            >
              刷新
            </el-button>
            
            <!-- 新建档案按钮 -->
            <el-button 
              type="success" 
              :loading="loading" 
              icon="el-icon-plus" 
              size="mini"
              @click="handleAddNew"
            >
              新建档案
            </el-button>
          </div>
        </div>
        
        <!-- 表格区域 -->
        <div class="table-container">
          <div class="table-wrapper">
            <!-- ===== 关键修改：使用 :height 动态绑定具体像素值 ===== -->
            <el-table 
              :data="tableData" 
              border 
              @row-dblclick="handleRowDblClick"
              @row-click="handleRowClick"
              element-loading-text="查询中" 
              element-loading-spinner="el-icon-more-outline"
              highlight-current-row 
              ref="singleTable" 
              style="width: 100%;"
              :height="tableHeight"
              :row-class-name="tableRowClassName"
            >
              <!-- 所有列保持不变 -->
              <el-table-column 
                fixed="left" 
                label="#" 
                type="index" 
                width="50" 
                align="center"
              ></el-table-column>
              
              <el-table-column 
                label="姓名" 
                prop="name" 
                width="100"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              
              <el-table-column 
                prop="sex" 
                label="性别" 
                width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span>
                    <i :class="scope.row.sex === 1 ? 'el-icon-male' : 'el-icon-female'" 
                        :style="{color: scope.row.sex === 1 ? '#409EFF' : '#F56C6C'}"></i>
                    {{ scope.row.sex === 1 ? '男' : '女' }}
                  </span>
                </template>
              </el-table-column>
              
              <el-table-column 
                prop="certno" 
                label="身份证号码" 
                width="160"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  {{ formatIdCard(row.certno) }}
                </template>
              </el-table-column>
              
              <el-table-column 
                prop="patId" 
                label="健康卡号" 
                width="120"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              
              <el-table-column 
                prop="tel" 
                label="联系电话" 
                width="120"
                align="center"
              ></el-table-column>
              
              <el-table-column 
                prop="brdy" 
                label="出生日期" 
                width="140"
                align="center"
              ></el-table-column>
              
              <el-table-column 
                prop="naty" 
                label="民族" 
                width="80"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span>{{ minZuMap[row.naty] || '-' }}</span>
                </template>
              </el-table-column>
              
              <el-table-column 
                prop="clinicName" 
                label="隶属诊所" 
                width="150"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              
              <el-table-column 
                prop="createId" 
                label="创建人" 
                width="100"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              
              <el-table-column 
                prop="createTime" 
                label="创建时间" 
                width="150"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              
              <el-table-column 
                fixed="right" 
                label="操作" 
                width="150" 
                align="center"
              >
                <template slot-scope="scope">
                  <div class="action-buttons" style="text-align: center; display: flex; justify-content: center; gap: 4px;">
                    <el-button 
                      type="primary" 
                      @click="handleViewDetail(scope.row)" 
                      size="mini"
                    >
                      详情
                    </el-button>

                    <template v-if="$store.getters.hasPermission('system:docphr:edit')">
                      <el-button 
                        type="warning" 
                        @click="handleEdit(scope.row)" 
                        size="mini"
                        :disabled="!isEditable(scope.row)"
                        :title="getEditButtonTitle(scope.row)"
                      >
                        修改
                      </el-button>
                    </template>
                    <template v-else>
                      <el-tooltip 
                        content="您当前暂无此操作权限，请联系管理人员！" 
                        placement="top"
                      >
                        <el-button 
                          type="warning" 
                          size="mini"
                          :disabled="true"
                        >
                          修改
                        </el-button>
                      </el-tooltip>
                    </template>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          
          <!-- 分页 -->
          <el-pagination 
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange" 
            :current-page="pageNum" 
            :page-sizes="[20, 50, 100]"
            :page-size="pageSize" 
            :total="totalSize" 
            layout="total, sizes, prev, pager, next, jumper"
            background 
            style="margin: 12px 0;"
          ></el-pagination>
        </div>
      </div>
    </div>
    
    <!-- 新增/修改/查看模态框 -->
    <div class="addmessagesBox">
      <addModel 
        ref="sonRef" 
        :parent-method="loadData"
        :clinic-name="clinicName"
        @mode-changed="handleDialogModeChange"
      ></addModel>
    </div>
  </div>
</template>

<script>
// 导入组件和接口
import addModel from './addHeal.vue';
import { docphrpage } from "@/api/Outpatient/Healthrecords.js";
import { dict } from "@/api/staff/staff.js";	

export default {
  name: 'HealthRecords',
  components: {
    addModel
  },
  computed: {
    hasEditPermission() {
      return this.$store.getters.hasPermission('system:docphr:edit');
    },
    hasViewPermission() {
      return this.$store.getters.hasPermission('system:docphr:view');
    },
    clinicName() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return userInfo.clinicName || '当前诊所';
    }
  },
  data() {
    return {
      windowWidth: '',
      searchValue: '',
      iconComes: 'el-icon-users',
      CatalogueName: '健康档案',
      createTime: '',
      dialogMode: 'add',
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalSize: 0,
      addForm: {},
      currentTable: {},
      // ===== 新增：表格高度 =====
      tableHeight: 400,
      minZuMap: {
        1: '汉族', 2: '蒙古族', 3: '回族', 4: '藏族', 5: '维吾尔族',
        6: '苗族', 7: '彝族', 8: '壮族', 9: '布依族', 10: '朝鲜族',
        11: '满族', 12: '侗族', 13: '瑶族', 14: '白族', 15: '土家族',
        16: '哈尼族', 17: '哈萨克族', 18: '傣族', 19: '黎族', 20: '傈僳族',
        21: '佤族', 22: '畲族', 23: '高山族', 24: '拉祜族', 25: '水族',
        26: '东乡族', 27: '纳西族', 28: '景颇族', 29: '柯尔克孜族', 30: '土族',
        31: '达斡尔族', 32: '仫佬族', 33: '羌族', 34: '布朗族', 35: '撒拉族',
        36: '毛南族', 37: '仡佬族', 38: '锡伯族', 39: '阿昌族', 40: '普米族',
        41: '塔吉克族', 42: '怒族', 43: '乌孜别克族', 44: '俄罗斯族', 45: '鄂温克族',
        46: '德昂族', 47: '保安族', 48: '裕固族', 49: '京族', 50: '塔塔尔族',
        51: '独龙族', 52: '鄂伦春族', 53: '赫哲族', 54: '门巴族', 55: '珞巴族',
        56: '基诺族', 57: '其他'
      },
      tableData: [],
      userInfo: [],
      MZOptions: [],
    };
  },
  mounted() {
    this.loadData();
    this.$nextTick(() => {
      this.updateWindowWidth();
      this.calculateTableHeight();
      window.addEventListener('resize', this.handleResize);
    });
    this.getditc();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // ===== 新增：计算表格高度 =====
    calculateTableHeight() {
      this.$nextTick(() => {
        const mainRight = this.$refs.mainRight;
        if (mainRight) {
          // 获取整体高度，减去头部和分页的高度
          const totalHeight = mainRight.clientHeight;
          // 头部约 60px，分页约 60px，上下内边距 16px*2=32px，边框等
          const otherHeight = 180;
          const height = Math.max(200, totalHeight - otherHeight);
          this.tableHeight = height;
        } else {
          // 后备方案
          const windowHeight = window.innerHeight;
          this.tableHeight = Math.max(200, windowHeight - 280);
        }
      });
    },
    
    // ===== 新增：窗口大小变化处理 =====
    handleResize() {
      this.updateWindowWidth();
      this.calculateTableHeight();
    },
    
    tableRowClassName({ row }) {
      if (row.sex === 1) {
        return 'male-row';
      } else if (row.sex === 2) {
        return 'female-row';
      } else {
        return 'Keyfemale-row';
      }
    },
    
    formatIdCard(idCard) {
      if (!idCard || typeof idCard !== 'string') {
        return '-';
      }
      if (idCard.length <= 10) {
        return idCard;
      }
      const firstPart = idCard.substring(0, 6);
      const lastPart = idCard.substring(idCard.length - 4);
      const maskedPart = '*'.repeat(Math.max(0, idCard.length - 10));
      return `${firstPart}${maskedPart}${lastPart}`;
    },
    
    handleSearch() {
      this.pageNum = 1;
      this.loadData();
    },
    
    handleRefresh() {
      this.loading = true;
      this.loadData();
      setTimeout(() => {
        this.$message.success('数据已刷新');
        this.loading = false;
      }, 500);
    },
    
    handleAddNew() {
      this.dialogMode = 'add';
      this.currentTable = {};
      this.$refs.sonRef.open({}, 'add');
    },
    
    async getditc() {
      try {
        const result = await dict();
        if (result.code === 200 && result.data) {
          localStorage.setItem('dict', JSON.stringify(result.data));
          this.MZOptions = (result.data.natyEntities || []).map(v => { 
            return { label: v.name, ...v }; 
          });
          this.MZOptions.forEach(item => {
            this.minZuMap[item.id] = item.label;
          });
        }
      } catch (error) {
        console.error('获取字典数据失败:', error);
      }
    },
    
    async loadData() {
      this.loading = true;
      try {
        let res = await docphrpage({
          name: this.searchValue,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        });
        if (res.code === 200 && res.data) {
          this.tableData = res.data.content || [];
          this.totalSize = res.data.totalSize || 0;
          this.tableData = this.tableData.map(item => {
            return {
              ...item,
              clinicName: item.clinicName || this.userInfo.clinicName || '未知诊所'
            };
          });
        } else {
          this.tableData = [];
          this.totalSize = 0;
          this.$message.error(res.message || '获取数据失败');
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败');
        this.tableData = [];
        this.totalSize = 0;
      } finally {
        this.loading = false;
        // 数据加载完成后重新计算表格高度
        this.calculateTableHeight();
      }
    },
    
    handleRowClick(row) {
      this.currentTable = row;
      this.setCurrent(row);
    },
    
    handleRowDblClick(row) {
      if (row) {
        this.dialogMode = 'view';
        this.$refs.sonRef.open(row, 'view');
      }
    },
    
    setCurrent(row) {
      this.$nextTick(() => {
        if (this.$refs.singleTable) {
          this.$refs.singleTable.setCurrentRow(row);
        }
      });
    },
    
    handleViewDetail(row) {
      this.dialogMode = 'view';
      this.currentTable = row;
      this.$refs.sonRef.open(row, 'view');
    },
    
    handleEdit(row) {
      this.dialogMode = 'edit';
      this.currentTable = row;
      this.$refs.sonRef.open(row, 'edit');
    },
    
    isEditable(row) {
      if (!row) return false;
      return true;
    },
    
    getEditButtonTitle(row) {
      if (!this.isEditable(row)) {
        return '当前状态下不可修改';
      }
      return '修改该条数据';
    },
    
    handleDialogModeChange(mode) {
      this.dialogMode = mode;
    },
    
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    
    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 368;
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  height: calc(100vh - 100px);
  width: 100%;
  overflow: hidden;

  /deep/ .el-table {
    .cell {
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    th {
      font-size: 12px;
      background-color: #f8f9fa;
      border: none;
      color: #2d2d2d;
      font-weight: bold;
      padding: 8px 0;
    }

    td {
      padding: 6px 0;
    }

    // ===== 关键：确保 body-wrapper 滚动 =====
    .el-table__body-wrapper {
      overflow-x: auto !important;
      overflow-y: auto !important;
    }
    
    .male-row {
      background-color: #e4f4ff !important;
      color: #00557f;
      &:hover > td {
        background-color: #ebf6ff !important;
      }
    }
    
    .female-row {
      background-color: #fff8fc !important;
      color: #aa557f;
      &:hover > td {
        background-color: #ffdde8 !important;
      }
    }
    
    .Keyfemale-row {
      background-color: #dddddd !important;
      color: #353535;
      &:hover > td {
        background-color: #dddddd !important;
      }
    }
  }

  /deep/ .el-table__body tr.current-row>td {
    background-color: #ecf5ff !important;
    color: #409EFF;
  }
  /deep/ .el-tabs__content{
    padding: 0px;
  }

  .main {
    display: flex;
    height: 100%;
    width: 100%;
    background: #f5f7fa;

    .main-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
      padding: 0;
      background: #fff;

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        background: #fff;
        border-bottom: 1px solid #e6e6e6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        flex-shrink: 0;
        min-height: 56px;

        .main-icon-a {
          display: flex;
          align-items: center;
        }

        .main-icon-c {
          display: flex;
          align-items: center;
          justify-content: start;
          margin-left: 12px;
          flex: 1;
          /deep/ .el-input {
            width: 200px;
          }
        }
      }

      .table-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        padding: 0 16px 0 16px;
        overflow: hidden;

        .table-wrapper {
          flex: 1;
          overflow: hidden;
          border-radius: 4px;
          border: 1px solid #e6e6e6;
          background: #fff;
          min-height: 0;
          position: relative;

          /deep/ .el-table {
            width: 100%;
            // 高度由 :height 动态控制
            
            .action-buttons {
              display: flex;
              justify-content: center;
              gap: 4px;
              
              .el-button {
                margin: 0;
                padding: 5px 8px;
                font-size: 12px;
                min-width: auto;
                
                &.is-disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .box {
    .main {
      .main-right {
        .main-icon {
          flex-wrap: wrap;
          gap: 10px;

          .main-icon-c {
            margin: 5px 0;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}

.el-button {
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
}
</style>